module.exports = __webpack_public_path__ + "img/astral_20.29cbf3a3.svg";